import React from 'react';
import styled from 'styled-components';
import useTabsTeuda from '../generic/tabList';

interface Props {
    activeTab: string;
    onChange: (tab: string) => void;
    isAllowToEdit: boolean;
    children: React.ReactNode;
    className?: string;
}

const TeudaTabs: React.FC<Props> = ({
    activeTab,
    onChange,
    isAllowToEdit,
    children,
    className,
}) => {
    const { TAB_LIST } = useTabsTeuda();
    // TAB_LIST[0] = "taken", TAB_LIST[1] = "rest". Show "rest" first.
    const render = isAllowToEdit ? [TAB_LIST[1], TAB_LIST[0]] : [TAB_LIST[0]];

    return (
        <Shell className={className}>
            <TabBar>
                {render.map((type) => (
                    <Tab
                        key={type}
                        type='button'
                        $active={activeTab === type}
                        onClick={() => onChange(type)}
                    >
                        {type}
                    </Tab>
                ))}
            </TabBar>
            <List>{children}</List>
        </Shell>
    );
};

export default TeudaTabs;

const Shell = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    direction: rtl;
`;

const TabBar = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    padding: 0.25rem;
    background: ${({ theme }) => theme.colors.line2};
    border: 1px solid ${({ theme }) => theme.colors.line};
    border-radius: ${({ theme }) => theme.radii.lg};
    align-self: flex-start;
`;

const Tab = styled.button<{ $active: boolean }>`
    appearance: none;
    border: 0;
    background: transparent;
    cursor: pointer;
    padding: 0.4rem 0.875rem;
    border-radius: ${({ theme }) => theme.radii.md};
    font-family: ${({ theme }) => theme.fonts.sans};
    font-size: ${({ theme }) => theme.text.md};
    font-weight: 500;
    color: ${({ theme }) => theme.colors.ink3};
    transition: all ${({ theme }) => theme.motion.fast} ease;

    ${({ $active, theme }) =>
        $active
            ? `
        background: ${theme.colors.surface};
        color: ${theme.colors.ink};
        box-shadow: 0 1px 2px rgba(0,0,0,0.04);
    `
            : `
        &:hover {
            color: ${theme.colors.ink2};
        }
    `}

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: ${({ theme }) => theme.textMobile.md};
        padding: 0.375rem 0.75rem;
    }
`;

const List = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;
